const MOCK_PARAM = 'cookiebot-mock';
const CMP_WAIT_MS = 3000;
const MOCK_BLOCKED_SRC_ATTR = 'data-cookieblock-src';
const MOCK_BLOCKED_PATTERN = /youtube|youtu\.be|vimeo/i;

export const ConsentState = {
  GRANTED: 'granted',
  DECLINED: 'declined',
  PENDING: 'pending',
  CMP_ABSENT: 'cmp-absent',
};

let mockedAbsent = false;
let settled = null;

function mockBlockIframes() {
  document.querySelectorAll('iframe[src]').forEach(iframe => {
    const src = iframe.getAttribute('src');

    if (!MOCK_BLOCKED_PATTERN.test(src)) return;

    iframe.setAttribute(MOCK_BLOCKED_SRC_ATTR, src);
    iframe.removeAttribute('src');
  });
}

function mockRestoreIframes() {
  document.querySelectorAll(`iframe[${MOCK_BLOCKED_SRC_ATTR}]`).forEach(iframe => {
    iframe.setAttribute('src', iframe.getAttribute(MOCK_BLOCKED_SRC_ATTR));
    iframe.removeAttribute(MOCK_BLOCKED_SRC_ATTR);
  });
}

function installMock() {
  if (window.location.hostname !== 'localhost') return;

  const mode = new URLSearchParams(window.location.search).get(MOCK_PARAM);
  if (!mode) return;

  if (mode === 'absent') {
    try {
      delete window.Cookiebot;
    } catch (error) {
      window.Cookiebot = undefined;
    }

    mockedAbsent = true;
    return;
  }

  const presets = {
    granted: { hasResponse: true, consented: true, marketing: true },
    declined: { hasResponse: true, consented: false, marketing: false },
    pending: { hasResponse: false, consented: false, marketing: false },
  };

  const preset = presets[mode];
  if (!preset) return;

  window.Cookiebot = {
    hasResponse: preset.hasResponse,
    consented: preset.consented,
    consent: {
      necessary: true,
      preferences: preset.marketing,
      statistics: preset.marketing,
      marketing: preset.marketing,
    },
    renew: () => {
      Object.assign(window.Cookiebot, { hasResponse: true, consented: true });
      Object.assign(window.Cookiebot.consent, { preferences: true, statistics: true, marketing: true });

      mockRestoreIframes();
      window.dispatchEvent(new Event('CookiebotOnAccept'));
    },
  };

  if (!preset.marketing) mockBlockIframes();
}

installMock();

export function getConsentState() {
  const cookiebot = window.Cookiebot;

  if (!cookiebot || !cookiebot.consent) return ConsentState.CMP_ABSENT;
  if (cookiebot.consent.marketing) return ConsentState.GRANTED;

  return cookiebot.hasResponse ? ConsentState.DECLINED : ConsentState.PENDING;
}

export function hasMarketingConsent() {
  return getConsentState() === ConsentState.GRANTED;
}

export function openConsentBanner() {
  const cookiebot = window.Cookiebot;

  if (cookiebot && typeof cookiebot.renew === 'function') {
    cookiebot.renew();
    return true;
  }

  return false;
}

export function onConsentChange(handler) {
  ['CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnConsentReady'].forEach(eventName => {
    window.addEventListener(eventName, () => handler(getConsentState()));
  });
}

export function whenCmpSettled() {
  if (settled) return settled;

  settled = new Promise(resolve => {
    if (mockedAbsent || window.Cookiebot) {
      resolve(getConsentState());
      return;
    }

    let timeout = null;
    let poll = null;
    let done = false;

    const finish = () => {
      if (done) return;
      done = true;

      clearTimeout(timeout);
      clearInterval(poll);
      window.removeEventListener('CookiebotOnConsentReady', finish);
      window.removeEventListener('CookiebotOnLoad', finish);

      resolve(getConsentState());
    };

    timeout = setTimeout(finish, CMP_WAIT_MS);
    poll = setInterval(() => {
      if (window.Cookiebot) finish();
    }, 100);

    window.addEventListener('CookiebotOnConsentReady', finish);
    window.addEventListener('CookiebotOnLoad', finish);
  });

  return settled;
}
